import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../api/request";

export const getInventoriesAPI = () => {
  return getRequest("/inventory");
};

// Opening inventories
export const createOpeningInventory = (payload) => {
  return postRequest("/inventory/opening", payload);
};

export const getOpeningInventoriesAPI = () => {
  return getRequest("/inventory/opening");
};

export const updateOpeningInventory = (id, payload) => {
  return putRequest(`/inventory/opening/${id}`, payload);
};
export const deleteOpeningInventory = (id) => {
  return deleteRequest(`/inventory/opening/${id}`);
};
